export default {
  data() {
    return {
      debounceTimer: null
    }
  },

  methods: {
    debounce (func, delay) {
      if (this.debounceTimer)
        clearTimeout(this.debounceTimer)

      this.debounceTimer = setTimeout(func, delay)
    }
  }
}
